import { Component, OnInit, HostBinding } from '@angular/core';
import {
  FormsModule,
  FormControl,
  Validators,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { slideInDownAnimation } from '../animation';
import { Router } from '@angular/router';
import { LoadingService, TokenService, UserService } from '../_shared/services';
import { errorMessages, regExps } from '../_shared';
import { MatInputModule, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    './forgot-password.component.css',
    '../../assets/css/core-login.css'
  ],
  animations: [slideInDownAnimation]
})
export class ForgotPasswordComponent implements OnInit {
  resetForm: FormGroup;
  private notifErrorModal = false;
  private notifSuccessModal = false;
  private globalErrorMessage: Object = null;
  public errorMessage: string = null;
  private errors = errorMessages;
  public successMessage: string;
  private loading: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private loadingService: LoadingService,
    private tokenService: TokenService
  ) {
    // check token if already exists so prevent from accessing login page and forgot password
    if (this.tokenService.getToken() != null) {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnInit() {
    this.resetForm = new FormGroup({
      emailControl: new FormControl(null, [
        Validators.required,
        Validators.pattern(regExps.email)
      ])
    });

    this.load(false);
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  reset() {
    this.loading = true;
    const email = {
      email: this.resetForm.value.emailControl
    };
    this.userService.resetPassword(email).subscribe(res => {
      console.log(res);
      if (res.success) {
        this.successMessage =
          'An e-mail has been sent, please check your inbox!';
        this.notifSuccessModal = true;
        this.loading = false;
      } else {
        this.errorMessage = res.errors;
        this.notifErrorModal = true;
        this.loading = false;
      }
    });
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/forgot-password/forgot-password.component.ts